/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M18.522 20.998a.577.577 0 0 1-.399-.16l-6.126-4.765-6.126 4.765a.563.563 0 0 1-.645.106.613.613 0 0 1-.258-.239.677.677 0 0 1-.096-.35V5.571c0-.681.254-1.335.704-1.817A2.325 2.325 0 0 1 7.272 3h9.45c.636 0 1.246.272 1.696.754a2.67 2.67 0 0 1 .704 1.817v14.784c0 .171-.063.334-.176.455a.58.58 0 0 1-.424.188Z"
})), "0 0 24 24", "Bookmark");